import { h } from "preact";
import { useState, useEffect, } from "preact/hooks";

import {
	Box,
	MenuItem,
	Popover,
	TextField,
	Tooltip,
	Typography,
} from "@mui/material";

import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

export default function FormSelect({ upperState, id, handleChange, helper, max }) {
	const [anchorEl, setAnchorEl] = useState(null);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};
	const value = upperState[id];
	const mnd = upperState[id + "_mnd"];
	const label = upperState[id + "_lbl"];
	const open = Boolean(anchorEl);
	return (
		<Box display="flex" justifyContent="space-between" alignItems="center" >
			<Box display="flex" justifyContent="flex-start" alignItems="center">
				<Box p={1}>
					<InfoIcon aria-haspopup="true"
						aria-owns={open ? 'mouse-over-popover' : undefined}
						onMouseEnter={handlePopoverOpen}
						onMouseLeave={handlePopoverClose}
						style="margin-top: 6px;"
						color={helper ? "" : "disabled"}
					/>
					<Popover
						id="mouse-over-popover"
						sx={{
							pointerEvents: 'none',
						}}
						open={open}
						anchorEl={anchorEl}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'left',
						}}
						onClose={handlePopoverClose}
						disableRestoreFocus
					>
						<Typography sx={{ p: 1 }}>{helper ? helper : <em>Pas encore d'aide, déso</em>}</Typography>
					</Popover>
				</Box>
				<Box p={1}>
					<Typography variant="body1">{label} {mnd ? "*" : null}</Typography>
				</Box>
				<Box p={1}>
					{upperState[id + "_fld"] ? <Tooltip title="Ce champ est obligatoire"><WarningIcon color="primary" /></Tooltip> : ""}
				</Box>
			</Box>
			<Box >
				<Floor name={id} val={value} setUpperState={handleChange} max={max} />
			</Box>
		</Box >
	);
}


function Floor({ name, val, setUpperState, defaultVal, max }) {
	const floors = new Array(
		"SS",
		//"ES",
		"RC",
		//"RJ",
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"8",
		"9",
		"10",
		"11",
		"12",
		"13",
		"14",
		"15",
		"16",
		"17",
		"18",
		"19",
		"20",
		"21",
		"22",
		"23",
		"24",
		"25",
		"26",
		"27",
		"28",
		"29",
		"30",
		"31",
		"32",
		"33",
		"34",
		"35",
		"36",
		"37",
		"38",
		"39",
		"40",
		"41",
		"42",
		"43",
		"44",
		"45",
		"46",
		"47",
		"48",
		"49",
		"50",
		"51",
		"52",
		"53",
		"54",
		"55",
		"56",
		"57",
		"58",
		"59"
	);

	return (
		<TextField
			id={name}
			name={name}
			select
			label=""
			value={val ? val : defaultVal}
			onChange={(val) => { console.log(val.target); setUpperState({ target: { name: name, value: val.target.value } }) }}
			helperText=""
			variant="outlined"
			size="small"
			margin="dense"
			style="min-width: 90px;"
		>
			{
				floors.filter((option) => { return option == "SS" || option == "RC" || parseInt(option) <= max }).map((option) => (
					<MenuItem key={option} value={option}>
						{option}
					</MenuItem>
				))
			}
		</TextField >
	);
};